module.exports = __webpack_public_path__ + "img/docking.6cd033fc.png";